import { useTranslations } from '@vocab/react';
import { Text, TextLink } from 'braid-design-system';

import translations from '../.vocab';

export const PrivacyAndCollectionNotice = () => {
  const { t } = useTranslations(translations);

  return (
    <Text size="xsmall" tone="secondary">
      {t('Don’t share sensitive information....', {
        CollectionNoticeLink: (children) => (
          <TextLink href="/collection-notice" weight="weak" target="_blank">
            {children}
          </TextLink>
        ),
        PrivacyLink: (children) => (
          <TextLink href="/privacy" weight="weak" target="_blank">
            {children}
          </TextLink>
        ),
      })}
    </Text>
  );
};
